import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { ItemChecklistMaquinaEquipForm, ItemChecklistMaquinaEquipSchema } from "../../../schemas/ChecklistMaquinaEquipItens_cadastro/item_checklist_maquina_equip";

import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { ChecklistMaquinaEquipItemModel } from "../../../../domain/models/checklist_maquina_equip_item";

/**
 * ItemChecklistItemMaquinaEquipModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedItemChecklistMaquinaEquip: ChecklistMaquinaEquipItemModel | null,
  onClose: (idItemChecklistMaquinaEquip: number | null, openState: boolean) => void;
  onSubmit: (form: ItemChecklistMaquinaEquipForm) => void;
};

export const ItemChecklistMaquinaEquipModal = ({
  open,
  saving,
  loading,
  selectedItemChecklistMaquinaEquip,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(ItemChecklistMaquinaEquipSchema),
  });

  useEffect(() => {
    if (open) {
      if (selectedItemChecklistMaquinaEquip) {
        hookForm.setValue('ordem', selectedItemChecklistMaquinaEquip.ordem ?? '');
        hookForm.setValue('descricao', selectedItemChecklistMaquinaEquip.descricao ?? '');
      } else {
        hookForm.reset();
      }
    }
  }, [
    open,
    selectedItemChecklistMaquinaEquip,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      width="50rem"
      title='Checklist de Máquina/Equipamento - Cadastro de Item'
      onClose={() => onClose(null, false)}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full flex flex-col">
        <FormContainer title='Informações' arrangement='fullRow' gap='small' border={false}>
          <>
            <DefaultFormInput
              name='ordem'
              label='Ordem'
              readOnly={saving}
              required={true}
              reactHookForm={hookForm}
            />

            <DefaultFormInput
              name='descricao'
              label='Descrição do Item'
              readOnly={saving}
              required={true}
              multiline={true}
              rows={5}
              reactHookForm={hookForm}
            />
          </>
        </FormContainer>
      </div>
    </BaseFormControlledModal >
  );
}